import React from "react";
import styles from "./Footer.module.scss";

const Footer = () => (
  <footer className={styles.footer}>
    <p>©2020 Krzysztof Zięcina</p>
  </footer>
);

export default Footer;
